import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { untilComponentDestroyed, OnDestroyMixin } from '@w11k/ngx-componentdestroyed';

import { MenuItem } from '../../bo/menuItem';
import { LoginModalService } from '../../shared/login/login-modal.service';
import { defs } from '../../defs';
import { GlobalService } from '../../global.service';
import { BalancesDto } from '../../api/balancesDto';
import { AuthService } from '../../shared/auth/auth.service';
import { menuItems } from './menuItems';
import { NGXLogger } from 'ngx-logger';
import { version } from '../../../../package.json';

export function greaterThanZero(fromState, toState) {
	return Number(toState) > 0;
}

@Component({
	selector: 'narwhalia-navbar',
	templateUrl: './navbar.component.html',
	styleUrls: ['./navbar.component.scss'],
	animations: [
		trigger('countChanged', [
			transition(
				greaterThanZero,
				animate(
					'1s ease-in-out',
					keyframes([
						style({
							transform: 'scale(1.5) rotate(0.02deg)',
							textShadow: '0 0 10px wheat',
							offset: 0.3
						}),
						style({
							transform: 'scale(1) rotate(0.02deg)',
							textShadow: 'none',
							offset: 1
						})
					])
				)
			)
		])
	]
})
export class NavbarComponent extends OnDestroyMixin implements OnInit {
	menuItems: MenuItem[];
	isLoggedIn: boolean;
	currentLang: string;
	balances: BalancesDto = new BalancesDto();
	showSellGlitterPopup: boolean;
	digitsInfo = defs.digitsInfo;
	public version: string = version;

	constructor(
		private loginModalService: LoginModalService,
		protected authService: AuthService,
		private router: Router,
		private globalService: GlobalService,
		private log: NGXLogger
	) {
		super();
		this.subscribeToRouterEvents();

		this.menuItems = menuItems;
		this.currentLang = 'en';
	}

	subscribeToRouterEvents() {
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.globalService.getBalances().subscribe();
			}
		});
	}

	ngOnInit() {
		this.globalService.balances$.pipe(untilComponentDestroyed(this)).subscribe(balances => {
			this.balances = balances;
			this.menuItems = this.menuItems.map(menuItem => {
				if (menuItem.count !== this.balances[menuItem.countKey]) {
					return { ...menuItem, count: this.balances[menuItem.countKey] };
				} else {
					return menuItem;
				}
			});
		});

		this.authService
			.isLoggedInAsObservable()
			.pipe(untilComponentDestroyed(this))
			.subscribe(isLoggedIn => {
				this.isLoggedIn = isLoggedIn;
				if (this.isLoggedIn) {
					this.globalService
						.getBalances()
						.pipe(untilComponentDestroyed(this))
						.subscribe();
				}
			});
	}

	toggleSellGlitter(event) {
		event.preventDefault();
		event.stopPropagation();
		this.showSellGlitterPopup = !this.showSellGlitterPopup;
	}

	closePopup() {
		this.showSellGlitterPopup = false;
	}

	openLoginModal() {
		this.loginModalService.open();
	}

	logout() {
		this.authService.logout();
		this.router.navigate(['/']);
	}

	help() {
		const splitted: string[] = this.router.url.match(/\/([^\?]*)\??.*/);
		this.log.trace('router.url: {0}, splitted: {1}', this.router.url, splitted);
		window.open('help/#' + splitted[1], '_narwhalia_help');
	}

}